import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:8001/api/v1";

function ModalCrearUsuario({ onCerrar, onCreado }) {
  const [form, setForm] = useState({
    username: "", nombre: "", apellido_paterno: "",
    apellido_materno: "", dependencia: "", unidad: "",
    password: "", es_admin: false,
    tokens_osint: 100, tokens_sigint: 0, tokens_cdr: 0
  });
  const [error, setError] = useState(null);
  const [cargando, setCargando] = useState(false);

  function actualizar(campo, valor) {
    setForm(function(f) { return { ...f, [campo]: valor }; });
  }

  async function crear() {
    setCargando(true);
    setError(null);
    try {
      await axios.post(API + "/admin/usuarios", form, { withCredentials: true });
      onCreado();
    } catch (e) {
      setError(e.response?.data?.detail || "Error al crear usuario");
    } finally {
      setCargando(false);
    }
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-full max-w-lg max-h-screen overflow-y-auto">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Nuevo Analista</h2>
        <div className="grid grid-cols-2 gap-3">
          {[
            { label: "Usuario", campo: "username" },
            { label: "Contraseña temporal", campo: "password" },
            { label: "Nombre(s)", campo: "nombre" },
            { label: "Apellido Paterno", campo: "apellido_paterno" },
            { label: "Apellido Materno", campo: "apellido_materno" },
            { label: "Dependencia", campo: "dependencia" },
            { label: "Unidad", campo: "unidad" },
          ].map(function(f) {
            return (
              <div key={f.campo}>
                <label className="text-gray-600 text-sm mb-1 block">{f.label}</label>
                <input
                  type={f.campo === "password" ? "password" : "text"}
                  value={form[f.campo]}
                  onChange={function(e) { actualizar(f.campo, e.target.value); }}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                />
              </div>
            );
          })}
        </div>

        <div className="mt-4">
          <label className="text-gray-600 text-sm mb-2 block font-medium">Tokens por módulo</label>
          <div className="grid grid-cols-3 gap-3">
            {[
              { label: "OSINT", campo: "tokens_osint" },
              { label: "SIGINT", campo: "tokens_sigint" },
              { label: "CDR", campo: "tokens_cdr" },
            ].map(function(t) {
              return (
                <div key={t.campo}>
                  <label className="text-gray-500 text-xs mb-1 block">{t.label}</label>
                  <input
                    type="number"
                    value={form[t.campo]}
                    onChange={function(e) { actualizar(t.campo, parseInt(e.target.value)); }}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                  />
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-4 flex items-center gap-2">
          <input
            type="checkbox"
            checked={form.es_admin}
            onChange={function(e) { actualizar("es_admin", e.target.checked); }}
            id="es_admin"
          />
          <label htmlFor="es_admin" className="text-gray-600 text-sm">
            Privilegios de Administrador
          </label>
        </div>

        {error && (
          <div className="bg-red-50 text-red-700 rounded-lg p-3 mt-3 text-sm">{error}</div>
        )}

        <div className="flex gap-3 mt-4">
          <button
            onClick={crear}
            disabled={cargando}
            className="flex-1 bg-gray-900 text-white py-2 rounded-lg font-medium hover:bg-gray-700 disabled:opacity-50"
          >
            {cargando ? "Creando..." : "Crear Analista"}
          </button>
          <button
            onClick={onCerrar}
            className="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg font-medium"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default function AdminPanel() {
  const [usuarios, setUsuarios] = useState([]);
  const [auditoria, setAuditoria] = useState([]);
  const [tab, setTab] = useState("usuarios");
  const [modal, setModal] = useState(false);
  const [cargando, setCargando] = useState(false);

  async function cargarUsuarios() {
    setCargando(true);
    try {
      const res = await axios.get(API + "/admin/usuarios", { withCredentials: true });
      setUsuarios(res.data.usuarios);
    } catch (e) {}
    setCargando(false);
  }

  async function cargarAuditoria() {
    try {
      const res = await axios.get(API + "/admin/auditoria", { withCredentials: true });
      setAuditoria(res.data.logs);
    } catch (e) {}
  }

  async function resetPassword(id) {
    if (!window.confirm("¿Resetear contraseña de este analista?")) return;
    try {
      const res = await axios.patch(
        API + "/admin/usuarios/" + id + "/reset",
        {},
        { withCredentials: true }
      );
      alert("Password temporal: " + res.data.password_temporal);
      cargarUsuarios();
    } catch (e) {}
  }

  async function desactivar(id) {
    if (!window.confirm("¿Desactivar esta cuenta?")) return;
    try {
      await axios.patch(
        API + "/admin/usuarios/" + id + "/desactivar",
        {},
        { withCredentials: true }
      );
      cargarUsuarios();
    } catch (e) {}
  }

  useEffect(function() {
    cargarUsuarios();
    cargarAuditoria();
  }, []);

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mt-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-800">⚙️ Panel de Administración</h2>
        <button
          onClick={function() { setModal(true); }}
          className="bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-700"
        >
          + Nuevo Analista
        </button>
      </div>

      <div className="flex gap-2 mb-4">
        <button
          onClick={function() { setTab("usuarios"); }}
          className={"px-4 py-2 rounded-lg text-sm font-medium " + (tab === "usuarios" ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-700")}
        >
          👥 Analistas ({usuarios.length})
        </button>
        <button
          onClick={function() { setTab("auditoria"); }}
          className={"px-4 py-2 rounded-lg text-sm font-medium " + (tab === "auditoria" ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-700")}
        >
          📋 Auditoría ({auditoria.length})
        </button>
      </div>

      {tab === "usuarios" && (
        <div className="overflow-x-auto">
          {cargando ? (
            <p className="text-gray-500 text-center py-4">Cargando...</p>
          ) : (
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-gray-50">
                  <th className="text-left p-3">Usuario</th>
                  <th className="text-left p-3">Nombre</th>
                  <th className="text-left p-3">Dependencia</th>
                  <th className="text-left p-3">OSINT</th>
                  <th className="text-left p-3">SIGINT</th>
                  <th className="text-left p-3">CDR</th>
                  <th className="text-left p-3">Estado</th>
                  <th className="text-left p-3">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {usuarios.map(function(u) {
                  return (
                    <tr key={u.id} className="border-t hover:bg-gray-50">
                      <td className="p-3 font-medium">
                        {u.username}
                        {u.es_admin ? <span className="ml-1 text-xs bg-blue-100 text-blue-700 px-1 rounded">Admin</span> : ""}
                      </td>
                      <td className="p-3">{u.nombre} {u.apellido_paterno}</td>
                      <td className="p-3 text-gray-500">{u.dependencia || "—"}</td>
                      <td className="p-3">
                        <span className="font-bold text-green-600">{u.tokens_osint}</span>
                      </td>
                      <td className="p-3">
                        <span className="font-bold text-blue-600">{u.tokens_sigint}</span>
                      </td>
                      <td className="p-3">
                        <span className="font-bold text-purple-600">{u.tokens_cdr}</span>
                      </td>
                      <td className="p-3">
                        <span className={"px-2 py-1 rounded-full text-xs " + (u.activo ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700")}>
                          {u.activo ? "Activo" : "Inactivo"}
                        </span>
                      </td>
                      <td className="p-3">
                        <div className="flex gap-2">
                          <button
                            onClick={function() { resetPassword(u.id); }}
                            className="text-xs bg-yellow-100 hover:bg-yellow-200 text-yellow-700 px-2 py-1 rounded"
                          >
                            Reset
                          </button>
                          {u.id !== 1 && (
                            <button
                              onClick={function() { desactivar(u.id); }}
                              className="text-xs bg-red-100 hover:bg-red-200 text-red-700 px-2 py-1 rounded"
                            >
                              Desactivar
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      )}

      {tab === "auditoria" && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-50">
                <th className="text-left p-3">Usuario</th>
                <th className="text-left p-3">Acción</th>
                <th className="text-left p-3">Módulo</th>
                <th className="text-left p-3">IP</th>
                <th className="text-left p-3">Fecha</th>
                <th className="text-left p-3">Resultado</th>
              </tr>
            </thead>
            <tbody>
              {auditoria.map(function(log) {
                return (
                  <tr key={log.id} className="border-t hover:bg-gray-50">
                    <td className="p-3 font-medium">{log.username || "—"}</td>
                    <td className="p-3">{log.accion}</td>
                    <td className="p-3 text-gray-500">{log.modulo}</td>
                    <td className="p-3 text-gray-500">{log.ip_origen}</td>
                    <td className="p-3 text-gray-500">{log.fecha_hora}</td>
                    <td className="p-3">
                      <span className={"px-2 py-1 rounded-full text-xs " + (log.resultado === "EXITOSO" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700")}>
                        {log.resultado}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {modal && (
        <ModalCrearUsuario
          onCerrar={function() { setModal(false); }}
          onCreado={function() { setModal(false); cargarUsuarios(); }}
        />
      )}
    </div>
  );
}